import React, { createContext, useState } from 'react';

export const HeaderPortalContext = createContext(null);

export default ({ children }) => {
  const [headerPortalContext, setHeaderPortalContext] = useState({
    children: null,
  });

  const context = { headerPortalContext, setHeaderPortalContext };

  return (
    <HeaderPortalContext.Provider value={context}>
      {children}
    </HeaderPortalContext.Provider>
  );
};
